import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';

export interface LinkWithCopyProps {
  href: string;
  children: React.ReactNode;
}

export const LinkWithCopy: React.FC<LinkWithCopyProps> = ({ href, children }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(href);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      // fallback or error
    }
  };

  return (
    <Box 
      component="span" 
      sx={{ 
        position: 'relative', 
        display: 'inline-flex', 
        alignItems: 'center' 
      }}
    >
      <Box 
        component="a" 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        sx={{ marginRight: 0.5 }}
      >
        {children}
      </Box>
      <Tooltip title={copied ? 'Copied!' : 'Copy link'} placement="top">
        <IconButton 
          size="small" 
          onClick={handleCopy} 
          sx={{ 
            padding: 0.25, 
            marginLeft: 0.5,
            minWidth: 'auto',
            minHeight: 'auto'
          }}
        >
          <ContentCopyIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
